module.exports = __webpack_public_path__ + "static/img/wall-conveyor-x2-steel_256.dba8911.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/wall-conveyor-x2-steel_256.png
// module id = Td6j
// module chunks = 0